import { PSI_LOGIN, GENERATE_REPORT,GENERATE_LAST_PORTFOLIO_INSIGHT,DOWNLOAD_PDF, AUTO_SUGGEST_SYMBOLS, GET_SYMBOL_PRICE, GET_INSTRUMENT_ID ,POST_PDF_DOWNLOAD_SUCCESS ,UPDATE_POST_PDF_DOWNLOAD_SUCCESS ,GET_BROKER_USER_HOLDINGS,GET_BROKER_ADMIN_USER_HOLDINGS, UPDATE_SUBSCRIPTION, SEND_REPORT_OVER_MAIL, GET_ACTIVE_MSI_PORTFOLIO, GET_MS_TRANSACTION_HISTORY, UPDATE_MSI_REPORT_SUBSCRIPTION, VALIDATE_HOLIDAY_DATE} from "../actions.type";
import { MyPortfolioListMSIApi, PsiReportsApi } from "../../api"
const state = {
  alphaScopeData: null,
  enableReport: false,
  portfolio: null,
  transactionData: null,
  is_premium:0
};

const mutations = {
  setAlphaScopeData(state, scopeData) {
    state.alphaScopeData = scopeData;
  },
  setEnableReport(state, flag) {
    state.enableReport = flag;
  },
  setPortfolio(state, portfolioData) {
    state.portfolio = portfolioData;
  },
  setTransactionData(state, transactionData) {
    state.transactionData = transactionData;
  },
  setGeneratedReportType(state, is_premium){
    state.is_premium = is_premium;
  }
};

const getters = {
  alphaScopeData: state => state.alphaScopeData,
  enableReport: state => state.enableReport,
  portfolio: state => state.portfolio,
  transactionData: state => state.transactionData,
  get_is_premium: state => state.is_premium
};

const actions = {
  setAlphaScopeData({ commit }, scopeData) {
    commit('setAlphaScopeData', scopeData);
  },
  setTransactionData({ commit }, transactionData) {
    commit('setTransactionData', transactionData);
  },
  setEnableReport({ commit }, flag) {
    commit('setEnableReport', flag);
  },
  setPortfolio({ commit }, portfolioData) {
    commit('setPortfolio', portfolioData);
  },
  setGeneratedReportType({ commit }, is_premium) {
    commit('setGeneratedReportType', is_premium);
  },
  [PSI_LOGIN]({ commit, dispatch }) {
    return PsiReportsApi.psilogin().then(response => {
      return response;
    });
  },
  [GENERATE_REPORT]({ commit, dispatch }, formData) {
    return PsiReportsApi.generatereport(formData).then(response => {
      return response;
    });
  },
  [GENERATE_LAST_PORTFOLIO_INSIGHT]({ commit, dispatch }, formData) {
    return PsiReportsApi.generatelastPortfolioInsight(formData).then(response => {
      return response;
    });
  },
  [AUTO_SUGGEST_SYMBOLS]({ commit, dispatch }, url) {
    return PsiReportsApi.autoSuggestSymbols(url).then(response => {
      return response;
    });
  },
  [DOWNLOAD_PDF]({commit,dispatch},formData){
    return PsiReportsApi.downloadPdf(formData).then(response => {
      return response;
    });
  },
  [GET_SYMBOL_PRICE]({commit,dispatch},url){
    return PsiReportsApi.getSymbolPrice(url).then(response => {
      return response;
    });
  },
  [GET_INSTRUMENT_ID]({commit,dispatch},url){
    return PsiReportsApi.getInstrumentId(url).then(response => {
      return response;
    });
  },
  [POST_PDF_DOWNLOAD_SUCCESS]({commit,dispatch},reportObj){
    return PsiReportsApi.pdfDownloadSuccess((reportObj)).then(response => {
      return response;
    });
  },
  [UPDATE_POST_PDF_DOWNLOAD_SUCCESS]({commit,dispatch},reportObj){
    return PsiReportsApi.updatepdfDownloadSuccess((reportObj)).then(response => {
      return response;
    })
  },
  [SEND_REPORT_OVER_MAIL]({commit,dispatch},reportObj){
    return PsiReportsApi.sendReportOverMail((reportObj)).then(response => {
      return response;
    });
  },
  [UPDATE_SUBSCRIPTION]({commit,dispatch}){
    return PsiReportsApi.updateSubscription().then(response => {
      return response;
    });
  },
  [GET_BROKER_USER_HOLDINGS]({ commit, dispatch }, brokerTokenObj) {
    return PsiReportsApi.getBrokerUserHoldings(brokerTokenObj).then(response => {
      return response;
    });
  },
  [GET_BROKER_ADMIN_USER_HOLDINGS]({ commit, dispatch }, brokerTokenObj) {
    return PsiReportsApi.getBrokerAdminUserHoldings(brokerTokenObj).then(response => {
      return response;
    });
  },

  [GET_ACTIVE_MSI_PORTFOLIO]({ commit, dispatch }, formData) {
    return MyPortfolioListMSIApi.getActivePortfolioList(formData).then(response => {
      return response;
    });
  },

  [GET_MS_TRANSACTION_HISTORY]({ commit, dispatch }, formData) {
    return MyPortfolioListMSIApi.getMsTransactionHistory(formData).then(response => {
      return response;
    });
  },
  [UPDATE_MSI_REPORT_SUBSCRIPTION]({ commit, dispatch }, formData) {
    return MyPortfolioListMSIApi.updateMsiReportSubscription(formData).then(response => {
      return response;
    });
  },
  [VALIDATE_HOLIDAY_DATE]({ commit, dispatch }, date) {
    return PsiReportsApi.validateHolidayDate(date).then(response => {
      return response;
    });
  },


};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/addholdings.js